import { useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import { FooterComponent, ErrorFallback } from 'bxcommon';
import Toaster from 'bxcommon/components/Toaster/Toaster';
import { ModalProvider } from 'bxcommon/context/ModalProvider';
import { RequestListContext } from 'bxcommon/context/RequestList.context';
import responseInterceptor from 'bxcommon/interceptors/response.interceptor';
import authHelper from 'bxcommon/helpers/auth.helper';
import setupLanguageHeader from 'bxcommon/helpers/language.helper';
import errorsService from 'bxcommon/helpers/errors.helper';
import { initToastUtils } from 'bxcommon/store/slices/toaster.slice';

import store from './store';
import RouteList from './RouteList';
import publicRoutes from './common/public-routes';
import { useGetAdvisorListQuery } from './store/endpoints/registry.endpoints';

import './App.scss';

responseInterceptor(store, publicRoutes);
authHelper.init('registry');
errorsService.init(store);
initToastUtils(store);
setupLanguageHeader();

const AdvisorListProvider = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.user?.loggedIn);
  const [page, setPage] = useState(1);
  const { data, isLoading } = useGetAdvisorListQuery({ page }, { skip: !isLoggedIn });
  return (
    <RequestListContext.Provider
      value={{ list: data?.results ?? [], count: data?.count ?? 0, isLoading, page, setPage }}
    >
      {children}
    </RequestListContext.Provider>
  );
};

const Layout = () => (
  <div className="primary-layout">
    <div className="primary-layout-content">
      <Toaster />
      <RouteList />
    </div>
    <FooterComponent />
  </div>
);

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <BrowserRouter>
          <ModalProvider>
            <AdvisorListProvider>
              <Layout />
            </AdvisorListProvider>
          </ModalProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
